import Input from "../../../../../components/inputField";
import { FunctionalButton } from "../../../../../components/functionalButton";
import React, { useState, useEffect } from "react";
import { ESubInfo } from "../types";
import { StyledQuestion } from "../../styles";
import { Row } from "../styles";
import PhoneInput from "react-phone-input-2";
import { StyledInput, StyledInputLabel, StyledInputLabelContainer } from "../../styles";
import { getCountryName } from "../../../../../common/countryName";

declare global {
  interface Window {
    google: any;
  }
}

type PrincipalInfoSectionProps = {
  esubData: ESubInfo;
  setESubData: (field: string, value: string) => void;
  isMobile: boolean;
  handleNext: () => void;
  panel: number;
  setPanel: (panel: number) => void;
  setIsLastPanel: (isLastPanel: boolean) => void;
  setPreviousStepPanel: (prevStepPanel: string) => void;
};

export const PrincipalInfoSection = ({
  esubData,
  setESubData,
  isMobile,
  handleNext,
  panel,
  setPanel,
  setIsLastPanel,
  setPreviousStepPanel,
}: PrincipalInfoSectionProps) => {
  useEffect(() => {
    console.log("[PrincipalInfoSection] Debug - esubData:", esubData);
  }, [esubData])
  console.log("Esub data: ", esubData);

  let autocomplete: any;
  let address1Field: any;
  let address2Field: any;
  let postalField: any;
  let cityField: any;
  let provinceField: any;
  let countryField: any;

  const initAutocomplete = () => {
    address1Field = document.querySelector("#principal-ship-address");
    address2Field = document.querySelector("#principal-address2");
    postalField = document.querySelector("#principal-postcode");
    cityField = document.querySelector("#principal-locality");
    provinceField = document.querySelector("#principal-state");
    countryField = document.querySelector("#principal-country");
    
    if (address1Field) {
      autocomplete = new window.google.maps.places.Autocomplete(address1Field, {
        componentRestrictions: { country: ["ca", "us"] },
        fields: ["address_components", "geometry"],
        types: ["address"],
      });
      autocomplete.addListener("place_changed", fillInAddress);
    }
  };

  const fillInAddress = () => {
    const place = autocomplete.getPlace();
    let address1 = "";
    let postcode = "";
    let city = "";
    let province = "";
    let country = "";

    for (const component of place.address_components) {
      const componentType = component.types[0];

      switch (componentType) {
        case "street_number": {
          address1 = `${component.long_name} ${address1}`;
          break;
        }

        case "route": {
          address1 += component.short_name;
          break;
        }

        case "postal_code": {
          postcode = `${component.long_name}${postcode}`;
          break;
        }

        case "postal_code_suffix": {
          postcode = `${postcode}-${component.long_name}`;
          break;
        }
        case "locality":
          city = component.long_name;
          break;
        case "country":
          country = component.short_name;
          break;
        case "administrative_area_level_1": {
          province = component.short_name;
          break;
        }
      }
    }

    // Update React state
    setESubData("project_info.principal_info.principal_address", address1);
    setESubData("project_info.principal_info.principal_postal_code", postcode);
    setESubData("project_info.principal_info.principal_city", city);
    setESubData("project_info.principal_info.principal_province", province);
    setESubData("project_info.principal_info.principal_country", country);

    // Focus on the suite field after a short delay to allow state update
    setTimeout(() => {
      if (address2Field) {
        address2Field.focus();
      }
    }, 100);
  };

  const loadScript = (url: string, callback: () => void) => {
    let script = document.createElement("script");
    script.type = "text/javascript";

    if ((script as any).readyState) {
      (script as any).onreadystatechange = function () {
        if (
          (script as any).readyState === "loaded" ||
          (script as any).readyState === "complete"
        ) {
          (script as any).onreadystatechange = null;
          callback();
        }
      };
    } else {
      script.onload = () => callback();
    }

    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
  };

  useEffect(() => {
    loadScript(
      `https://maps.googleapis.com/maps/api/js?key=AIzaSyCwLidsAgErglXnD9dT6qnaQF7u_DYU3Pc&libraries=places`,
      () => initAutocomplete()
    );
  }, []); // Empty dependency array to run only once

  const postalCode = esubData?.project_info?.principal_info?.principal_postal_code;
  const canadianPostalCodePattern = /^[A-Za-z]\d[A-Za-z]\s?\d[A-Za-z]\d$/;
  const usaZipCodePattern = /^\d{5}(?:[-\s]\d{4})?$/;

  return (
    <>
      <StyledQuestion isMobile={isMobile} width="650px">
        Who is the Principal of the Bond?
      </StyledQuestion>
      <Input
        label="Principal Name"
        type="text"
        fontSize="18px"
        labelSize="12px"
        value={esubData?.project_info?.principal_info?.principal_name || ""}
        setValue={(e) => setESubData("project_info.principal_info.principal_name", e)}
        backgroundColor=""
        color=""
        placeholder=""
        validateFunc={() => true}
        style={{}}
        withoutMargin={false}
        marginTop=""
        id=""
        labelWeight=""
        labelColor=""
        inputHeight=""
        inputWidth=""
        borderRadius=""
        borderColor=""
        focusBorderColor=""
        disabled={false}
        readOnly={false}
        maxLength={undefined}
        minLength={undefined}
        pattern=""
        required={false}
        autoComplete=""
        autoFocus={false}
        marginRight=""
      />
      <Row>
        <Input
          label="Email"
          type="text"
          fontSize="18px"
          labelSize="12px"
          value={esubData?.project_info?.principal_info?.principal_email || ""}
          setValue={(e) => setESubData("project_info.principal_info.principal_email", e)}
          backgroundColor=""
          color=""
          placeholder=""
          validateFunc={() => true}
          style={{}}
          withoutMargin={false}
          marginTop=""
          id=""
          labelWeight=""
          labelColor=""
          inputHeight=""
          inputWidth=""
          borderRadius=""
          borderColor=""
          focusBorderColor=""
          disabled={false}
          readOnly={false}
          maxLength={undefined}
          minLength={undefined}
          pattern=""
          required={false}
          autoComplete=""
          autoFocus={false}
          marginRight=""
        />
        <div
          style={{
            marginTop: "24px",
            width: "95%",
            marginLeft: "0px",
            marginRight: "20px",
          }}
        >
          <label
            htmlFor="phone"
            style={{ fontSize: "12px", marginLeft: "0px" }}
          >
            Phone Number
          </label>
          <div
            style={{
              height: "47px",
              width: "100%",
              marginTop: "-10px",
              marginLeft: "0px",
            }}
          >
            <PhoneInput
              country={"ca"}
              value={esubData?.project_info?.principal_info?.principal_phone || ""}
              onChange={(e) => setESubData("project_info.principal_info.principal_phone", e)}
              inputStyle={{
                fontSize: "18px",
                padding: "8px",
                lineHeight: "24px",
                marginLeft: "20px",
                paddingLeft: "28px",
                height: "100%",
                width: "100%",
              }}
              dropdownStyle={{ fontSize: "18px", lineHeight: "24px" }}
              className="custom-phone-input"
            />
          </div>
        </div>
      </Row>

      <Row>
        <div style={{ flex: 1 }}>
          <StyledInputLabelContainer>
            <StyledInputLabel htmlFor="principal-locality">Location</StyledInputLabel>
            <StyledInput
              id="principal-ship-address"
              required
              width="317"
              value={esubData?.project_info?.principal_info?.principal_address || ""}
              placeholder=""
              autoComplete="off"
              onChange={(event) =>
                setESubData(
                  "project_info.principal_info.principal_address",
                  event.target.value
                )
              }
            />
          </StyledInputLabelContainer>
        </div>
        <div style={{ flex: "0 0 15%" }}>
          <StyledInputLabelContainer>
            <StyledInputLabel htmlFor="principal-address2">Suite</StyledInputLabel>
            <StyledInput
              id="principal-address2"
              aria-label="suite"
              width="90"
              value={esubData?.project_info?.principal_info?.principal_suite || ""}
              onChange={(event) =>
                setESubData(
                  "project_info.principal_info.principal_suite",
                  event.target.value
                )
              }
            />
          </StyledInputLabelContainer>
        </div>
        <div style={{ flex: 1 }}>
          <StyledInputLabelContainer>
            <StyledInputLabel htmlFor="principal-postcode">
              {
                canadianPostalCodePattern.test(postalCode) ? "Postal Code" : usaZipCodePattern.test(postalCode) ? "Zip Code" : "Postal/Zip Code"
              }
            </StyledInputLabel>
            <StyledInput
              id="principal-postcode"
              required
              width="210"
              value={esubData?.project_info?.principal_info?.principal_postal_code || ""}
              onChange={(event) =>
                setESubData(
                  "project_info.principal_info.principal_postal_code",
                  event.target.value
                )
              }
            />
          </StyledInputLabelContainer>
        </div>
      </Row>

      <Row>
        <div style={{ flex: 1 }}>
          <StyledInputLabelContainer>
            <StyledInputLabel htmlFor="principal-locality">City</StyledInputLabel>
            <StyledInput
              id="principal-locality"
              required
              width="318"
              value={esubData?.project_info?.principal_info?.principal_city || ""}
              onChange={(event) =>
                setESubData(
                  "project_info.principal_info.principal_city",
                  event.target.value
                )
              }
            />
          </StyledInputLabelContainer>
        </div>
        <div style={{ flex: "0 0 15%" }}>
          <StyledInputLabelContainer>
            <StyledInputLabel htmlFor="principal-state">
              {
                canadianPostalCodePattern.test(postalCode) ? "Province" : usaZipCodePattern.test(postalCode) ? "State" : " Province/State"
              }
            </StyledInputLabel>
            <StyledInput
              id="principal-state"
              required
              width="90"
              value={esubData?.project_info?.principal_info?.principal_province || ""}
              onChange={(event) =>
                setESubData(
                  "project_info.principal_info.principal_province",
                  event.target.value
                )
              }
            />
          </StyledInputLabelContainer>
        </div>
        <div style={{ flex: 1 }}>
          <StyledInputLabelContainer>
            <StyledInputLabel htmlFor="principal-country">Country</StyledInputLabel>
            <StyledInput
              id="principal-country"
              required
              width="210"
              value={getCountryName(esubData?.project_info?.principal_info?.principal_country || "")}
              onChange={(event) =>
                setESubData(
                  "project_info.principal_info.principal_country",
                  event.target.value
                )
              }
            />
          </StyledInputLabelContainer>
        </div>
      </Row>

      <FunctionalButton
        buttonTitle="Next"
        handleButton={() => {
          handleNext();
          setPanel(2);
        }}
        width={undefined}
        height={undefined}
        isReversedColor={undefined}
        marginRight={undefined}
        marginLeft={undefined}
        marginTop={"40px"}
        marginBottom={undefined}
        fontSize={undefined}
        disabled={undefined}
        icon={undefined}
        hasBoxShadow={undefined}
        frontIcon={undefined}
        weight={undefined}
        borderColor={undefined}
        selected={undefined}
      />
    </>
  );
};
